module.exports = __webpack_public_path__ + "img/VT admites first Negro.0f85fba0.jpg";